import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActiveRemittance } from '../../../../../models/remittances/active-remittance';
import { BaseButtonSizeEnum } from '../../base-button/base-button-size.enum';
import { Routes } from '../../../../../routes/routes';

@Component({
  selector: 'app-employer-contribution-scheduled-remittance',
  templateUrl: './employer-contribution-scheduled-remittance.component.html',
  styleUrls: ['../employer-contributions.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerContributionScheduledRemittanceComponent {
  @Input() activeRemittance!: ActiveRemittance;

  public goToRemittance(): void {
    const baseUrl = window.location.origin;
    const hashUrl = Routes.ipEditScheduledRemittance(this.activeRemittance.id);
    const fullUrl = `${baseUrl}/#${hashUrl}`;
    window.open(fullUrl, '_blank', 'noopener,noreferrer');
  }

  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
}
